import { render, staticRenderFns } from "./PageSoumission.vue?vue&type=template&id=2e382324&scoped=true"
import script from "./PageSoumission.vue?vue&type=script&lang=js"
export * from "./PageSoumission.vue?vue&type=script&lang=js"
import style0 from "./PageSoumission.vue?vue&type=style&index=0&id=2e382324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e382324",
  null
  
)

export default component.exports